import Default from './default';
import Restrict from './restrict';

export default { Default, Restrict };
